/* tslint:disable */
/* eslint-disable */
/**
 * Yago API
 * Augemented Reality Made Easy.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@genie-ar.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TimeRangeEnum {
    _24h = '24h',
    _48h = '48h',
    _7d = '7d',
    _14d = '14d',
    _1m = '1m',
    _2m = '2m',
    _3m = '3m',
    _6m = '6m',
    _1y = '1y',
    _2y = '2y'
}

export function TimeRangeEnumFromJSON(json: any): TimeRangeEnum {
    return TimeRangeEnumFromJSONTyped(json, false);
}

export function TimeRangeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeRangeEnum {
    return json as TimeRangeEnum;
}

export function TimeRangeEnumToJSON(value?: TimeRangeEnum | null): any {
    return value as any;
}

